export default __webpack_public_path__ + "static/media/cow-1.7e0f69e4.png";